import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getPointsHistory, writeToStorageCacheQuery } from '~services'
import { PointsHistoryResponse } from '~types/pointsHistory'

const { POINTS_HISTORY } = QUERY_KEYS

const pointsHistoryQueryKey = [POINTS_HISTORY] as [string]

export function usePointsHistory(
  options?: UseQueryOptions<PointsHistoryResponse, unknown, PointsHistoryResponse>
) {
  const {
    isLoading: isFetchingPointsHistory,
    refetch: refetchPointsHistory,
    data,
  } = useQuery<PointsHistoryResponse>(pointsHistoryQueryKey, getPointsHistory, {
    keepPreviousData: true,
    onSuccess: (data) => {
      writeToStorageCacheQuery(pointsHistoryQueryKey, data)
    },
    ...options,
  })
  return { pointsHistory: data?.pointsHistory, isFetchingPointsHistory, refetchPointsHistory }
}

usePointsHistory.queryKey = () => pointsHistoryQueryKey
